// Displays the dashboard page containing the list of the number of open and
// occupied parking spaces in the parking lot. It also contains links to sections and the number
// of parking spaces in each section.

import React from 'react';
// import { Link } from 'react-router-dom';
// import axios from 'axios';
import styles from '../css/dashboard.module.css';
import board from '../assets/dashboard.png';

const dashboard = () => {
  const spacesArray = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24];
  return (
    <div className={styles.dashboardContainer}>
      <header>
        <div className={styles.headerContainer}>
          <div className={styles.mainContainer}>
            <div className={styles.topMenuContainer}>
              <button>
                {/* This is google material symbols icon. 
              See index.css and index.html for more information.
              If I change the name to menu, it will show the menu icon. 
              If I change it to home, it will show the home icon. */}
                <span className={`material-symbols-rounded ${styles.materialSymbolsRounded}`}>dashboard</span>
              </button>
              <h1>Precision Parking Dashboard</h1>
            </div>
          </div>
          <div className={styles.technicianProfile}>
            <span className={styles.technicianName}>Dashboard</span>
            <div>
              <img
                src={board}
                alt="dashboard"
                style={{
                  width: '48px',
                  height: '48px',
                  objectFit: 'cover',
                  borderRadius: '50%',
                }}
              />
            </div>
          </div>
        </div>
      </header>
      <main>
        <section className={styles.topSection}>
          <div className={styles.occupancyContainer}>
            <div className={styles.realTimeContainer}>
              <h2 className={styles.realTimeTitle}>Real Time Occupancy</h2>
              <div className={styles.liveContainer}>
                <span className={styles.livetext}></span>Live
                <span className="material-symbols-outlined">parking_valet</span>
              </div>
            </div>
            <div className={styles.occupancyDataContainer}>
              <div>
                <p>Total Available</p>
                <p style={{ fontSize: '2rem' }}>142</p>
              </div>
              <div>
                <p>Capacity</p>
                <p style={{ fontSize: '2rem' }}>450</p>
              </div>
            </div>
          </div>
          <div className={styles.searchContainer}>
            <p className={styles.quickSearchTitle}>Quick Search</p>
            <div className={styles.searchInputContainer}>
              <span
                className="material-symbols-outlined"
                style={{
                  color: '#a7c8ff',
                  position: 'absolute',
                  top: '14%',
                  transform: 'translateX(50%)',
                }}
              >
                search
              </span>
              <input className={styles.quickSearchInput} placeholder="Find specific level..." type="text" />
            </div>
            <p className={styles.searchDescription}>Filter by floor, section or space number.</p>
          </div>
        </section>
        <div>
          <div style={{ marginBottom: '30px' }}>
            <div className={styles.parkingSpotsContainer}>
              <div className={styles.parkingTitleContainer}>
                <div className={styles.sectionTitle}>01</div>
                <h2>South Property | A Lot North</h2>
              </div>
              <span>48/60 Slots Full</span>
            </div>
            <div className={styles.spacesGridContainer}>
              <div className={styles.spaceBlock}>
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    lineHeight: '28px',
                  }}
                >
                  <span className={styles.spaceNumber}>Lanes 1-10</span>
                  <span className={styles.spaceNumberStatus}>Available</span>
                </div>
                <span
                  class="material-symbols-outlined"
                  style={{
                    width: '40px',
                    height: '40px',
                    textAlign: 'center',
                    paddingTop: '7px',
                  }}
                >
                  add
                </span>
              </div>
              <div className={styles.spaceBlock}>
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    lineHeight: '28px',
                  }}
                >
                  <span className={styles.spaceNumber}>Lanes 11-15</span>
                  <span className={styles.spaceNumberStatus}>Available</span>
                </div>
                <span
                  class="material-symbols-outlined"
                  style={{
                    width: '40px',
                    height: '40px',
                    textAlign: 'center',
                    paddingTop: '7px',
                  }}
                >
                  add
                </span>
              </div>
              <div className={styles.spaceBlock}>
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    lineHeight: '28px',
                  }}
                >
                  <span className={styles.spaceNumber}>Lanes 16-20</span>
                  <span className={styles.spaceNumberStatus}>Available</span>
                </div>
                <span
                  className="material-symbols-outlined"
                  style={{
                    width: '40px',
                    height: '40px',
                    textAlign: 'center',
                    paddingTop: '7px',
                  }}
                >
                  add
                </span>
              </div>
            </div>
          </div>
          <div>
            <div className={styles.parkingSpotsContainer}>
              <div className={styles.parkingTitleContainer}>
                <div className={styles.sectionTitle}>01</div>
                <h2>South Property | B Lot East</h2>
              </div>
              <span>48/60 Slots Full</span>
            </div>
            <div className={styles.spacesGridContainer}></div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default dashboard;
